import Command from '@ckeditor/ckeditor5-core/src/command';

export default class InsertVar extends Command {
    execute() {
        this.editor.model.change( writer => {
            writer.insertText( '## text ##' );
        } );
    }
}
